import { CheckIcon } from "@/modules/Core/Icons/Check";
import { Box, Button, Typography } from "@mui/material";
import FileUpload from "./FileUpload";
import { useEffect, useState } from "react";
import InfoModal from "./InfoModal";
import { useSelector } from "react-redux";
import axios from "axios";
import { base64toBlob } from "@/utils/Base64ToBlob";
import { ApiService } from "@/api/service/ApiService";
import { useReject } from "@/hooks/useReject";

const BlockWithFileUpload = ({
  incomeView,
  getIncomeView,
  getUploadedFiles,
  uploadedFiles,
  verifyIncome,
}) => {
  const [isOpen, setisOpen] = useState(false);
  const {
    responseInfo: { id },
    clientInfo: { iin },
  } = useSelector((state: any) => state.user);
  const { api } = ApiService();
  const { setRejectOpen, setInfoKey } = useReject();

  useEffect(() => {
    getIncomeView();
  }, []);

  const uploadFile = async (content, file, setFile) => {
    try {
      const { data } = await api.post(
        `/application/growing-business/verification-docs/views/${incomeView?.id}/doc`,
        {
          id: `${file?.lastModified}`,
          type: incomeView.content[0].docType,
          fileName: file.name,
          content: content,
        }
      );

      if (data) {
        await getUploadedFiles();
        setFile(null);
      }
    } catch (e) {
      setFile(null);
      throw e;
    }
  };

  const deleteFile = async (docId) => {
    try {
      const { data } = await api.delete(
        `application/growing-business/verification-docs/doc?docId=${docId}`
      );

      await getUploadedFiles();

      return data;
    } catch (e) {
      throw e;
    }
  };

  const getAgreement = async (payload) => {
    try {
      const { data } = await axios.get(
        `${process.env.NEXT_PUBLIC_BASE_URL}/colvir/agreement/${payload}`
      );
      return data;
    } catch (e) {
      setInfoKey("7");
      setRejectOpen(true);
      throw e;
    }
  };

  const generateAgreement = async () => {
    getAgreement(iin).then((result) => {
      const base64 = result.data;
      const blob = base64toBlob(base64, "application/pdf");
      window.open(URL.createObjectURL(blob), "_blank")?.focus();
    });
  };

  return (
    <Box>
      <Typography
        component="p"
        variant="h4"
        textAlign="center"
        marginBottom="40px"
        sx={(theme) => ({
          fontSize: "40px",
          fontWeight: "700",
          lineHeight: "130%",
          [theme.breakpoints.down("sm")]: {
            fontSize: "24px",
            fontWeight: "700",
            lineHeight: "32px",
            marginBottom: "24px",
          },
        })}
      >
        Документы подтверждающие доход
      </Typography>
      <Box
        sx={(theme) => ({
          maxWidth: "968px",
          padding: "32px",
          borderRadius: "32px 32px 0px 0px",
          backgroundColor: "#FFF",
          margin: "0 auto",
        })}
        // ref={ref}
      >
        <Box
          sx={(theme) => ({
            display: "flex",
            [theme.breakpoints.down("sm")]: {
              flexDirection: "column",
              marginBottom: "8px",
            },
          })}
        >
          <Typography
            sx={(theme) => ({
              fontSize: "18px",
              fontWeight: "700",
              lineHeight: "28px",
              color: "#000",
            })}
          >
            Справка с другого банка о доходах
          </Typography>
          <Box
            sx={(theme) => ({
              display: "flex",
              alignItems: "center",
              padding: "4px 8px",
              borderRadius: "6px",
              backgroundColor: "#E8E8E8",
              gap: "4px",
              marginLeft: "16px",
              [theme.breakpoints.down("sm")]: {
                marginLeft: "0",
                width: "146px",
              },
            })}
          >
            <CheckIcon color="#808185" />
            <Typography
              sx={(theme) => ({
                color: "#808185",
                fontSize: "12px",
                fontWeight: "400",
                lineHeight: "16px",
                whiteSpace: "nowrap",
              })}
            >
              +15% к одобрению
            </Typography>
          </Box>
        </Box>
        <Typography
          sx={(theme) => ({
            color: "#676971",
            fontSize: "16px",
            fontWeight: "400",
            lineHeight: "22px",
          })}
        >
          Справка должна содержать ФИО подписанта, подпись и печать Банка.
          Отсканируйте ее в формате PDF.
        </Typography>
        <Typography
          sx={(theme) => ({
            color: "#676971",
            fontSize: "16px",
            fontWeight: "400",
            lineHeight: "22px",
            marginBottom: "24px",
          })}
        >
          Принимаются также электронные справки из приложений Kaspi или Jusan с
          QR-кодом.{" "}
          <a
            role="button"
            style={{
              color: "#27AE60",
              textDecoration: "underline",
              cursor: "pointer",
            }}
            onClick={() => {
              setisOpen(true);
            }}
          >
            Подробнее
          </a>
        </Typography>
        <FileUpload
          incomeView={incomeView}
          uploadedFiles={uploadedFiles}
          deleteFile={deleteFile}
          uploadFile={uploadFile}
        />
        <Box
          sx={(theme) => ({
            display: "flex",
            justifyContent: "space-between",
            paddingTop: "16px",
            marginTop: "16px",
            borderTop: "1px solid #D1D5E5",
            [theme.breakpoints.down("sm")]: {
              flexDirection: "column",
            },
          })}
        >
          <Typography
            sx={(theme) => ({
              color: "#8B8E99",
              fontSize: "14px",
              lineHeight: "21px",
              [theme.breakpoints.down("sm")]: {
                fontSize: "12px",
                lineHeight: "16px",
              },
            })}
          >
            Нажимая кнопку Получить решение онлайн я даю свою согласие{" "}
            <a role="button" onClick={generateAgreement}>
              <Typography
                component="span"
                sx={(theme) => ({
                  color: "#27AE60",
                  cursor: "pointer",
                  fontSize: "14px",
                  lineHeight: "21px",
                  [theme.breakpoints.down("sm")]: {
                    fontSize: "12px",
                    lineHeight: "16px",
                  },
                })}
              >
                на сбор, обработку и использование моих персональных данных
              </Typography>
            </a>
            , и разрешаю сделать запрос в кредитное бюро.
          </Typography>
          <Button
            onClick={verifyIncome}
            // disabled={!isValidEmail(email)}
            sx={(theme) => ({
              minWidth: "198px",
              //   padding: "13px 24px",
              marginLeft: "16px",
              maxHeight: "48px",
              borderRadius: "10px",
              backgroundColor: "#27AE60",
              color: "#FFF",
              fontSize: "16px",
              fontWeight: "500",
              lineHeight: "22px",
              ":hover": {
                background: "#27AE60",
                color: "#FFF",
              },
              [theme.breakpoints.down("sm")]: {
                margin: "16px 0 0",
              },
            })}
          >
            Получить решение
          </Button>
        </Box>
      </Box>
      {isOpen && <InfoModal open={isOpen} setOpen={setisOpen} />}
    </Box>
  );
};

export default BlockWithFileUpload;
